import { MessageDescriptor } from 'react-intl';
import * as yup from 'yup';
import http from '../../api';
import messages from './messages';

export const getValidationSchema = (
  companyId: string,
  siteId: string,
  pinLengthSetting: number,
  formatMessage: (message: MessageDescriptor, values?: Record<string, number>) => string,
  shouldValidateLengthRef?: { current: boolean }
) =>
  yup.object({
    customPin: yup
      .string()
      .test(
        'check-length',
        formatMessage(messages.userPinModalErrorMessageWrongLength, { pinLength: pinLengthSetting }),
        function (value) {
          const pin = value || '';
          if (shouldValidateLengthRef?.current) {
            return pin.length === pinLengthSetting;
          }
          return true;
        }
      )
      .test('no-silly-pin', formatMessage(messages.userPinModalErrorMessageUnsecure), function (value) {
        const pin = value || '';

        if (pin.length !== pinLengthSetting) {
          return true;
        }

        const isAscending = pin.split('').every((digit, index, arr) => index === 0 || +digit === +arr[index - 1] + 1);
        const isDescending = pin.split('').every((digit, index, arr) => index === 0 || +digit === +arr[index - 1] - 1);
        const isAllSame = /^(\d)\1*$/.test(pin);

        return !(isAscending || isDescending || isAllSame);
      })
      .test({
        message: formatMessage(messages.userPinModalErrorMessageAlreadyExists),
        name: 'is-unique-pin',
        test: async (pin) => {
          if (pin?.length !== pinLengthSetting) {
            return true;
          }

          try {
            const response = await http.post(
              `/fe/companies/${companyId}/sites/${siteId}/credentials/available-custom-pin`,
              { pin }
            );
            return response.status === 204;
          } catch (error: any) {
            if (error.response?.status === 409) {
              return false;
            }
            return true;
          }
        },
      }),
  });
